import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { ProcessListWidget } from "./Components/ProcessList.jsx";

export function RenderProcesses(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      (
        <ProcessListWidget configuration={configuration} />
      ),
    );
}


document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".process-list-widget-config");

    for (let config of widget_configs) {
        RenderProcesses(JSON.parse(config.innerText));
    }
});
